import { isRemember } from "@/helper/RememberMe";
export default function hasToken() {
    return isRemember() ? localStorage.getItem("token") : sessionStorage.getItem("token");
}
